import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const MinLengthValidator = z.literal('minLength');
export type TMinLengthValidator = z.infer<typeof MinLengthValidator>;

export const MinLengthValidatorParamsSchema = z.object({
  minLength: z.number(),
});

export type TMinLengthValidatorParams = z.infer<typeof MinLengthValidatorParamsSchema>;

export const MinLengthValidatorSchema = BaseValidatorSchema.extend({
  type: MinLengthValidator,
  value: MinLengthValidatorParamsSchema,
});
